import { render } from "./PricingCTAHero.vue?vue&type=template&id=0b6227a2&scoped=true"
import script from "./PricingCTAHero.vue?vue&type=script&lang=js"
export * from "./PricingCTAHero.vue?vue&type=script&lang=js"

import "./PricingCTAHero.vue?vue&type=style&index=0&id=0b6227a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6227a2"]])

export default __exports__